import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-court-800 bg-court-950 py-14 text-white" data-id="element-81" data-mp="3gfsmscqd8umz">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 sm:px-8 lg:flex-row lg:items-start lg:justify-between" data-id="element-82" data-mp="32o4bucrusc7l">
        <div className="max-w-md" data-id="element-83" data-mp="36oo9dhgc9hu9">
          <p className="font-display text-lg font-extrabold tracking-tight text-ball" data-id="element-84" data-mp="36ppk1ktg02bg">
            🎾 TENNIS 360™ · Class Room
          </p>
          <p className="mt-3 text-sm leading-relaxed text-court-600" data-id="element-85" data-mp="38h5b9u0hiky">
            The complete coaching system for tennis coaches worldwide.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-court-600" data-id="element-86" data-mp="3ldu874b9l61m">
            Because coaching shouldn't cost you every evening of the week.
          </p>
        </div>

        <ul className="space-y-3 text-sm" data-id="element-87" data-mp="29y5gy0qz9kv0">
          <li data-id="element-88" data-mp="2a19uvpu8vuyv">
            <a href="mailto:support@classroomonline.org" className="flex items-center gap-2.5 text-court-600 transition-colors duration-150 ease-smooth hover:text-ball focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ball" data-id="element-89" data-mp="2eya1q2yx51r1">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="3gcjw6rxsy2hf" />
              support@classroomonline.org
            </a>
          </li>
          <li data-id="element-91" data-mp="3q83s3ecd9166">
            <a href="https://tennis.classroomonline.org" className="flex items-center gap-2.5 text-court-600 transition-colors duration-150 ease-smooth hover:text-ball focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ball" data-id="element-92" data-mp="3q7ln9tbn1emn">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="htd4te2ty487" />
              tennis.classroomonline.org
            </a>
          </li>
        </ul>
      </div>

      <p className="mx-auto mt-12 max-w-6xl px-5 text-xs text-court-700 sm:px-8" data-id="element-94" data-mp="cvtlw0v6t39x">
        © TENNIS 360™ · Class Room 2025 — All Rights Reserved.
      </p>
    </footer>;
}